export default __webpack_public_path__ + "static/media/male_mouth.946d5b06.png";